import { createStore } from 'effector';
import dayjs from 'dayjs';
import { PayoutOrderStatus } from '~/entities/payout';
import { Currency } from '~/entities/currency';
import { resetFilters, setFilters } from './events';
import { type Filters } from './types';

const initial: Filters = {
    orderId: {
        value: undefined,
    },
    statuses: [PayoutOrderStatus.STATUS_INVESTIGATION],
    publicStatuses: [],
    currency: [Currency.CURRENCY_RUB],
    requisiteSuffixes: [],
    requisiteType: 'card',
    createdAtGt: dayjs().subtract(1, 'day').startOf('day').toISOString(),
};

export const $filters = createStore<Filters>(initial)
    .reset(resetFilters)
    .on(setFilters, (source, payload) => {
        return { ...source, ...payload };
    });
